export const MASTER_DATA = {
  ADDRESS_TYPE: "Address Type",
  BLOOD_GROUPS: "Blood Group",
  DISTRICTS: "districts",
  EMPLOYMENT_STATUS: "employment_status",
  EMPLOYMENT_TYPE: "employment_type",
  GENDER: "Gender",
  MARITAL_STATUS: "Marital Status",
  OFFICE_TYPE: "OfficeType",
  POST_TYPE: "postType",
  RELATIONSHIP: "Relationship",
  RELIGION: "Religion",
  RESULT: "Result",
  ATTENDANCE_STATUS: "attendance_status",
  LEAVE_STATUSES: "LeaveStatus",
  LEAVE_NATURE: "LeaveNature",
  PERFORMANCE_COMMENT: "acrPerformanceComment",
  PERFORMANCE_ELIGIBILITY: "acrPerformanceEligibility",
  PERFORMANCE_STATUS: "acrPerformanceStatus",
};
